import React from "react";
import { Col, Row } from "react-bootstrap";

export default function PdfParameterProgressBar({ name, score }) {
  if (score <= 0) score = 0;
  else score = Number(score).toFixed(0);

  const progressColor = "#4a90e2";
  const backgroundColor = "#e0e0e0";

  return (
    <Row className="mb-2">
      <Col xs="3" className="align-content-center">
        <div style={{ fontSize: "12px", fontWeight: "600", color: "#333" }}>{name}</div>
      </Col>
      <Col xs="9" className="align-content-center">
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* Percentage text */}
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#333",
              minWidth: "45px",
            }}
          >
            {score}%
          </div>

          {/* Loading bar */}
          <div
            style={{
              flex: 1,
              height: "18px",
              backgroundColor: backgroundColor,
              borderRadius: "9px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${score}%`,
                backgroundColor: progressColor,
                borderRadius: "9px",
                transition: "width 0.3s ease",
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
